import { encryptedTime } from '../../../../config/encrypted-time'
import type { IGetTime } from '../../domain/use-cases/i-get-time'

export class GetTimeController {
  constructor(readonly repository: IGetTime) {}

  async getTime(): Promise<any> {
    try {
      const result = await this.repository.getTime()
      // Converte a string para Date
      const dateResult = new Date(result)
      return encryptedTime(dateResult)
    } catch (error: any) {
      throw error
    }
  }
}
